import React, { Component } from 'react';

import { getTranslation } from '../Utilities/GetTranslation.js'
import Overview from './Pages/Overview.js';

declare var globalSns;

class TabsWizard extends Component {
    constructor(props) {
        super(props);
        
        this.state = {
            authenticated: this.props.authenticated,
            showPreviousBtn: false,
            showNextBtn: true,
            showFinishBtn: false,
            compState: 0,
            navState: this.getNavStates(0, this.props.steps.length),
            overview: this.props.overview
        };
        
        this.handleOnClick = this.handleOnClick.bind(this);
        this.cancelOverview = this.cancelOverview.bind(this);
        this.goToStep = this.goToStep.bind(this);
        this.finish = this.finish.bind(this);
        this.next = this.next.bind(this);
        this.previous = this.previous.bind(this);
    }

    getNavStates(indx, length) {
        let styles = [];
        for (let i=0; i<length; i++) {
            if(i < indx) {
                styles.push('submitted')
            }
            else if(i === indx) {
                styles.push('active')
            }
        }
        return { current: indx, styles: styles }
    }

    // Checks first / last step
    checkNavState(currentStep){
        if(currentStep > 0 && currentStep < this.props.steps.length - 1){
            this.setState({
                showPreviousBtn: true,
                showNextBtn: true,
                showFinishBtn: false,
            })
        }
        else if(currentStep === 0) {
            this.setState({
                showPreviousBtn: false,
                showNextBtn: true,
                showFinishBtn: false
            })
        }
        else {
            this.setState({
                showPreviousBtn: true,
                showNextBtn: false,
                showFinishBtn: true
            })
        }
    }

    // Checks and triggers the step validation
    async isCurrentStateValid() {
        if (this.refs.activeComponent == null || typeof this.refs.activeComponent.isValidated === "undefined") {
            // no validation function
            return true;
        }
    
        return await this.refs.activeComponent.isValidated();
    }


    // Navigate to a step
    async setNavState(next) {
        if (await this.isCurrentStateValid()) {
            this.initialPosition();
            this.setState({navState: this.getNavStates(next, this.props.steps.length)})
            if (next < this.props.steps.length) {
                this.setState({compState: next})
            }
            this.checkNavState(next);      
        }
    }

    // Navigation Click
    handleOnClick(evt) {
        if (evt.currentTarget.value === (this.props.steps.length - 1) &&
         this.state.compState === (this.props.steps.length - 1)) {
            this.setNavState(this.props.steps.length)
        }
        else {
            this.setNavState(evt.currentTarget.value)
        }
    }

    async finish() {
        if (await this.isCurrentStateValid(true)) {
            if (this.props.finishUrl != null) {
                window.location = this.props.finishUrl;
            }
        }
    }

    async overview() {
        if (await this.isCurrentStateValid(true)) {
            this.initialPosition();
            this.setState({overview: true});
        }
    }

    cancelOverview() {
        this.initialPosition();
        this.setState({overview: false});
    }

    async goToStep(step) {
        await this.setNavState(step);
        this.setState({overview:false});
    }

    next() {
        this.setNavState(this.state.compState + 1)
    }

    previous() {
        if (this.state.compState > 0) {
            this.setNavState(this.state.compState - 1)
        }
    }

    getClassName(i){
        return this.state.navState.styles[i];
    }

    initialPosition() {
        window.location.hash = "";
        window.location.hash = "content";
    }

    renderSteps() {
        return this.props.steps.map((s, i)=> (
            <li onClick={this.handleOnClick} key={i} value={i}>
                <a href="# " className={this.getClassName(i)}>{this.props.steps[i].name}</a>
            </li>
        ));
    }

    render() {
        var _this = this;
        let ext = {};
        ext.ref = "activeComponent"
        ext.job = this.props.job;
        ext.authenticated = this.state.authenticated;
        ext.onGoNext = function() {
            _this.next();

        }
        ext.onAuthenticated = function() {
            _this.setState({
                authenticated: true
            });
        }
        ext.onOverview = function() {
            _this.setState({
                overview: true
            });
        }

        let step = React.cloneElement(this.props.steps[this.state.compState].component, ext);

        if (this.state.overview) {
            return (
                <div className="registration">
                    <Overview onCancel={this.cancelOverview} onFinish={this.finish} onGoToStep={this.goToStep} steps={this.props.steps} job={this.props.job}  />
                </div>
            );
        }

        return (
            <div className="registration">
                <div className="registration-steps col-xs-12">
                    <ul>
                        {this.renderSteps()}
                    </ul>
                </div>
                <div className="EditingFormTable table">
                    {step}
                    <div className="tr text-right col-md-8 button-wrapper">
                        {this.state.showPreviousBtn ?
                            <input type="button" ref={el => this.btnPrevious = el} id="prevbutton"
                                className="FormButton btn btn-primary previous"
                                value={getTranslation("sns.custom.jobapply.prev")}
                                onClick={this.previous} /> :
                            ""
                        }
                        {this.state.showNextBtn ?
                            <input type="button" id="nextbutton"
                                className="FormButton btn btn-primary next"
                                value={getTranslation("sns.custom.jobapply.next")}
                                onClick={this.next} /> :
                            ""
                        }           
                        {globalSns.step == null && this.state.showFinishBtn ?
                            <input type="button" ref={el => this.btnFinish = el} id="finishbutton"
                                className="FormButton btn btn-primary next"
                                value={getTranslation("sns.custom.jobapply.finish")}
                                onClick={this.finish} /> :
                            ""                        
                        }
                    </div>
                </div>
            </div>
        );
    }
}

export default TabsWizard;


// WEBPACK FOOTER //
// ./src/Components/TabsWizard.js